import type { DocumentDI, IdDI } from '@onefootprint/types';
import getDataLabel from '../components/entities/components/details/components/content/components/document-details-dialog/components/drawer-content/utils/get-data-label';

const DATA_LABEL_ORDERING = [
  'name',
  'full_name',
  'first_name',
  'middle_name',
  'last_name',
  'dob',
  'ssn4',
  'ssn9',
  'gender',
  'full_address',
  'address_line1',
  'address_line2',
  'city',
  'state',
  'postal_code',
  'zip',
  'country',
  'document_number',
  'expires_at',
  'issued_at',
  'issuing_country',
  'us_issuing_state',
  'issuing_state',
  'ref_number',
  'nationality',
  'document_type',
  'curp',
  'clave_de_elector',
];

const getDocumentDataLabelOrdering = (key: DocumentDI | IdDI | string) => {
  const field = getDataLabel(key);
  const index = DATA_LABEL_ORDERING.indexOf(field);

  return index !== -1 ? index : DATA_LABEL_ORDERING.length;
};

export default getDocumentDataLabelOrdering;
